import { render, staticRenderFns } from "./PaymentsRt.vue?vue&type=template&id=c8cdeab6"
import script from "./PaymentsRt.vue?vue&type=script&lang=js"
export * from "./PaymentsRt.vue?vue&type=script&lang=js"
import style0 from "./PaymentsRt.vue?vue&type=style&index=0&id=c8cdeab6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports